export const getLocaleSiteOptions = (state) => (locale) => {
  return state.sites.map((site) => {

    return {
      title: site.title[locale],
      uid: site.uid
    };
  });
};
